import { render, staticRenderFns } from "./AppHero.vue?vue&type=template&id=10386240&scoped=true&"
import script from "./AppHero.vue?vue&type=script&lang=js&"
export * from "./AppHero.vue?vue&type=script&lang=js&"
import style0 from "./AppHero.vue?vue&type=style&index=0&id=10386240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10386240",
  null
  
)

export default component.exports